



















import { Component, Vue } from "vue-property-decorator";
import SimpleTable from "@/basics/table/SimpleTable.vue";
import NoData from "@/basics/boxes/NoData.vue";
import { GROUP_ALL, GroupAllData } from "@/graphql/query/group/all";
import { USER_ME, UserMeData } from "@/graphql/query/user/me";
import { check, Scopes } from "@/lib/scope";

export interface Group {
  id: string;
  name: string;
}

@Component({
  components: {
    SimpleTable,
    NoData
  },
  apollo: {
    groups: {
      query: GROUP_ALL,
      update(data: GroupAllData): Group[] {
        return data.groupFeed.groups
      }
    },
    scopes: {
      query: USER_ME,
      update(data: UserMeData): Scopes {
        return data.me.scopes
      }
    }
  }
})
export default class GroupsList extends Vue {
  scopes: Scopes = []
  groups: Group[] = []

  check = check
}
